/**
 * Custom Vue entry point.
 * This module is aliased as 'vue' in webpack so that configureCompat
 * is called as a side-effect BEFORE any other module (including bootstrap-vue)
 * evaluates Vue-level APIs. This prevents the warning flood and
 * the "Multiple instances of Vue" false-positive from BootstrapVue.
 */
import { configureCompat } from '@vue/compat'

configureCompat({
  MODE: 2,
  RENDER_FUNCTION: 'suppress-warning',
  COMPONENT_FUNCTIONAL: 'suppress-warning',
  COMPONENT_ASYNC: 'suppress-warning',
  INSTANCE_LISTENERS: 'suppress-warning',
  INSTANCE_SCOPED_SLOTS: 'suppress-warning',
  INSTANCE_EVENT_EMITTER: 'suppress-warning',
  OPTIONS_BEFORE_DESTROY: 'suppress-warning',
  GLOBAL_EXTEND: 'suppress-warning',
  GLOBAL_PROTOTYPE: 'suppress-warning',
  GLOBAL_MOUNT: 'suppress-warning',
  OPTIONS_DATA_MERGE: 'suppress-warning',
  COMPONENT_V_MODEL: 'suppress-warning',
  FILTERS: 'suppress-warning',
  WATCH_ARRAY: 'suppress-warning',
  ATTR_FALSE_VALUE: 'suppress-warning',
  ATTR_ENUMERATED_COERCION: 'suppress-warning',
  CONFIG_WHITESPACE: 'suppress-warning',
})

export * from '@vue/compat'
export { default } from '@vue/compat'
